import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {firstDayMonth, firstDayWeek, firstDayYear, toBrDate} from "../../../utils/date";
import {ShortcutButton, ShortcutRow} from "./styles";

const SHORTCUTS = [
    {key: 'TODAY', label: 'filter_shortcut_today', getStart: () => new Date()},
    {key: 'THIS_WEEK', label: 'filter_shortcut_this_week', getStart: firstDayWeek},
    {key: 'THIS_MONTH', label: 'filter_shortcut_this_month', getStart: firstDayMonth},
    {key: 'THIS_YEAR', label: 'filter_shortcut_this_year', getStart: firstDayYear},
];

/**
 * Estado dos atalhos de período (Hoje, Esta semana, Este mês, Este ano).
 * `onApply(startDate, endDate)` recebe as datas no formato dd/mm/aaaa, igual ao submit do form.
 * `inputKey` muda a cada atalho pra remontar os InputDate com o novo período.
 */
export function useDateShortcuts(onApply, initialShortcut = 'THIS_MONTH') {
    const [activeShortcut, setActiveShortcut] = useState(initialShortcut);
    const [version, setVersion] = useState(0);
    const [dateRange, setDateRange] = useState({
        startDate: firstDayMonth(),
        endDate: new Date(),
    });

    function applyShortcut(key) {
        const shortcut = SHORTCUTS.find((item) => item.key === key);
        const startDate = shortcut.getStart();
        const endDate = new Date();

        setActiveShortcut(key);
        setDateRange({startDate, endDate});
        setVersion((value) => value + 1);
        onApply(toBrDate(startDate), toBrDate(endDate));
    }

    return {
        activeShortcut,
        dateRange,
        inputKey: version,
        applyShortcut,
        clearShortcut: () => setActiveShortcut(null),
    };
}

export default function DateShortcuts({activeShortcut, applyShortcut}) {
    const { t } = useTranslation();

    return (
        <ShortcutRow>
            {SHORTCUTS.map((shortcut) => (
                <ShortcutButton
                    key={shortcut.key}
                    type="button"
                    $active={activeShortcut === shortcut.key}
                    aria-pressed={activeShortcut === shortcut.key}
                    onClick={() => applyShortcut(shortcut.key)}
                >
                    {t(shortcut.label)}
                </ShortcutButton>
            ))}
        </ShortcutRow>
    );
}
